import { Footer } from '@aperza/header-footer';
import { AppConfig } from '@aperza/util';

export const GlobalFooter = () => (
  <footer data-service="search" data-issociallink="false" data-ismultilang="false">
    <Footer type={AppConfig.APERZA_TV} />
  </footer>
);
